import React from 'react';
import { Skeleton } from 'src/components-dummy/Skeleton';
import {
  EmptyCardsContainer,
  ImageSkeleton,
  ImagesRow,
  SkeletonHeader,
} from './CampaignPreview.styles';

export const CampaignPreviewSkeleton = (): JSX.Element => {
  return (
    <EmptyCardsContainer>
      <SkeletonHeader>
        <Skeleton width='100%' height={24} />
      </SkeletonHeader>
      <ImagesRow>
        <ImageSkeleton />
        <ImageSkeleton />
        <ImageSkeleton />
        <ImageSkeleton />
      </ImagesRow>
    </EmptyCardsContainer>
  );
};
